// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"167":"6ee63ada","213":"4a436300","698":"de8e5c47","732":"782e122c"}[chunkId] + ".js";
};